module.exports = new __parcel__URL__("exercise2.734c75b2.png").toString();